import React, { type ReactElement } from 'react';
import clsx from 'clsx';
import styles from './summary.module.scss';

type SummaryProps = {
  currentPage: number;
  itemsPerPage: number;
  totalItems: number;
};

export default function Summary({
  currentPage,
  itemsPerPage,
  totalItems
}: SummaryProps): ReactElement {
  // Note: the API always returns 1 as the smallest page, even when there are 0 totalItems. So, we
  // have to explicitly handle this case on the frontend by setting startOfRange to 0:
  const startOfRange = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endOfRange = Math.min(totalItems, itemsPerPage * currentPage);

  return (
    <div className={clsx('text-body-secondary', styles.summary)}>
      <span>
        showing {startOfRange} - {endOfRange} of {totalItems} results
      </span>
    </div>
  );
}
